import { api } from './api';
import type { TestGuidance, TestGuidanceBundle, TestType } from '@sr-test-wizard/shared';

export interface CreateGuidanceInput {
  testKey: string;
  description?: string;
  passedCriteria?: string;
  failedCriteria?: string;
  naCriteria?: string;
  naComment?: string;
  conceptIds?: string[];
  testType?: TestType;
}

export interface UpdateGuidanceInput {
  testKey?: string;
  description?: string;
  passedCriteria?: string;
  failedCriteria?: string;
  naCriteria?: string;
  naComment?: string;
  conceptIds?: string[];
  testType?: TestType;
}

/**
 * Typed wrappers around /api/test-guidance. The shared types come from
 * @sr-test-wizard/shared so FE and BE agree on the wire shape
 * automatically when the schema is edited.
 */
export const testGuidanceApi = {
  list: () => api.get<TestGuidanceBundle>('/api/test-guidance'),
  create: (input: CreateGuidanceInput) => api.post<TestGuidance>('/api/test-guidance', input),
  update: (id: string, input: UpdateGuidanceInput) =>
    api.put<TestGuidance>(`/api/test-guidance/${encodeURIComponent(id)}`, input),
  remove: (id: string) =>
    api.delete<{ id: string; removed: boolean }>(`/api/test-guidance/${encodeURIComponent(id)}`),
};
